import { useRef } from 'react';

import { trackingUtils } from '@debijenkorf/dbk-common';
import { useTracking } from '@debijenkorf/hooks';

type UsePromotionTrackingArgs = {
  id: string;
  name: string;
  title: string;
};

export const usePromotionTracking = ({ id, name, title }: UsePromotionTrackingArgs) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { onClickEvent } = useTracking({});

  useTracking({
    targetRef: ref,
    displayEventData:
      id && name && title ? trackingUtils.viewPromotionEvent({ id, name, title }) : undefined,
  });

  const handleBannerAnalytics = () => {
    if (!id && !name && !title) return;

    onClickEvent(trackingUtils.selectPromotionEvent({ id, name, title }));
  };

  return { ref, handleBannerAnalytics };
};
